/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvUlEQVR4nN1UPUscURT1G+xctNIfoIWWWoiyZZCZd+9dzdt7Z0HSLYhNKlNuq/iBdlZWgqAkjdoJ6QKxEsFGV3FrESRpsqJseOMmjjuP9e24lQ8OzAdzzj33njstLe/65PP5TkUSKJQdILlQKGVF8kuhFM0zH4MZrXVXInJFPA0kJSCpvIIrHwNqhLtVIW84EFeiUCirhUKh7fXKUdYbJYf/4JW65ADyMTm5PDkhRiu5GRYgX79VAEhKJhzx1pAETSCvhMiwtgjwXrMEFMq2bbjFpjkguYgPmORPEx38tjkoJyR7AJJFL5MdRsyNAPGSQrmLO0C+TCiwYJlnPKqAstt45uUsnU53GCjib4DyVWvdbluDRDFFzH4Ii8vI/LMoz9VbNPc2oeyb7zwvlwLiG0WyZWCuET/12F0gf3HrO98D6MHov8vz9ACA9FddrMXIfT/oA+Rzt95zSOBPB0OhGEnFz2RHiYKx2gL+tacbkH84puaWaLa3mpbDiKufgHIcuT+IxmqzgVh+Dqsnnno5cB73KZiwhcBs8bJCfnSp3vNyqWpRp9F3hhyRJ2uCcGIdtstRJN8dHB8lFnA9fwF3sa7ygoEZnAAAAABJRU5ErkJggg==)
 */
export const ChatWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.03 21.5c-.05.28-.27.5-.54.5H2.2a1 1 0 0 1-.75-1.66l2.06-2.37a.52.52 0 0 0 .04-.61 10 10 0 1 1 18.32-3.77c-.01.12-.17.14-.22.04a3.06 3.06 0 0 0-5.3 0l-3.95 6.9c-.19.32-.3.65-.37.98Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 14.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.93 1.93 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
